import React from 'react';
import { motion } from 'framer-motion';
const researchAreas = [{
  number: '01',
  title: 'Decision Patterns',
  description: 'How successful partners make decisions under pressure and uncertainty'
}, {
  number: '02',
  title: 'Alignment Signals',
  description: 'Early indicators of where alignment forms and begins to fracture'
}, {
  number: '03',
  title: 'Conflict Navigation',
  description: 'How leaders identify, address, and repair relationship strain'
}, {
  number: '04',
  title: 'Performance Impact',
  description: 'Operational and financial costs of unresolved partnership issues'
}, {
  number: '05',
  title: 'Success Predictors',
  description: 'Behavioral patterns that predict long-term partnership outcomes'
}, {
  number: '06',
  title: 'Emotional Dynamics',
  description: 'The psychological toll of partnership strain on founders'
}];
export function FindingsSection() {
  return <section className="px-[60px] py-[140px] relative" style={{
    background: 'linear-gradient(180deg, #B5EAD7 0%, #C5F467 100%)'
  }} data-id="element-1041">
      <div className="max-w-[1400px] mx-auto" data-id="element-1042">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-1043">
          <div className="inline-flex items-center px-4 py-2 rounded bg-[#1A3D3A] text-white mb-6" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '12px',
          fontWeight: 600,
          letterSpacing: '3px',
          lineHeight: 1.0,
          borderRadius: '4px'
        }} data-id="element-1044">
            OUR RESEARCH
          </div>
          <h2 className="text-[#1A3D3A] mb-6" style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '56px',
          fontWeight: 500,
          lineHeight: 1.1,
          letterSpacing: '-1px'
        }} data-id="element-1045">
            What We Study
          </h2>
          <p className="text-[#3D5654] max-w-[600px] mx-auto" style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '18px',
          fontWeight: 400,
          lineHeight: 1.7
        }} data-id="element-1046">
            Evidence-based inquiry into the interpersonal and behavioral
            dynamics that shape how founders and leaders work together.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1047">
          {researchAreas.map((area, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white/80 backdrop-blur-sm rounded-[12px] p-10 relative hover:-translate-y-1 transition-all focus-within:outline-none focus-within:ring-3 focus-within:ring-[#0D2926] focus-within:ring-offset-2" style={{
          boxShadow: '0 8px 40px rgba(26, 61, 58, 0.1)',
          border: '1px solid rgba(26, 61, 58, 0.15)'
        }} data-id="element-1048">
              <div className="absolute top-5 right-5 text-[#1A3D3A]" style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: '14px',
            fontWeight: 400,
            opacity: 0.5
          }} data-id="element-1049">
                {area.number}
              </div>
              <h3 className="text-[#1A3D3A] mb-3" style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: '26px',
            fontWeight: 500,
            lineHeight: 1.3
          }} data-id="element-1050">
                {area.title}
              </h3>
              <p className="text-[#3D5654]" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '15px',
            fontWeight: 400,
            lineHeight: 1.6
          }} data-id="element-1051">
                {area.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}